module.exports = __webpack_public_path__ + "img/car_icon.a35fea66.png";